<div class="search-page-container">
  <app-card>
    <div>
      <div class="search-header">
        <span class="title">Datenbank durchsuchen</span>
        <app-search-area style="width: 100%;" [criteriaOffer]="criteriaOffer"
                         [setAllBranches]="branches"
                         [setProjRoles]="projRoles"
                         [setTechnologies]="technologies"
                         (onSearch)="onSearch($event)">
        </app-search-area>
      </div>
      <!-- <h5 class="mb-4">Datenbank durchsuchen</h5>
      <div class="">
        <h6>{{'filter_area' | translate}}</h6>
      </div> -->
      <!-- <div class="card px-3 pt-3">
        <app-search-area [criteriaOffer]="criteriaOffer"
                         [setAllBranches]="branches"
                         [setProjRoles]="projRoles"
                         [setTechnologies]="technologies"
                         (onSearch)="onSearch($event)">
        </app-search-area>
      </div> -->
    
      <!-- --------------- SEARCH RESULT TABLE ----------------- -->
    
      <div class="table-wrapper">
        <table class="cv-table" mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef>{{'firstname' | translate}}</th>
            <td mat-cell *matCellDef="let cv"> {{cv.firstname}} </td>
          </ng-container>
        
          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef>{{'lastname' | translate}}</th>
            <td mat-cell *matCellDef="let cv"> {{cv.lastname}} </td>
          </ng-container>
        
          <ng-container matColumnDef="language">
            <th mat-header-cell *matHeaderCellDef>{{'language' | translate}}</th>
            <td mat-cell *matCellDef="let cv"> {{cv.language}} </td>
          </ng-container>
        
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>{{'actions' | translate}}</th>
            <td mat-cell *matCellDef="let cv">
              <div class="buttons-row">
                <button mat-mini-fab
                        class="icon-button"
                        (click)="goToCv(cv.id, cv.language)"
                        matTooltip="{{'show_profile' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="account_box"></mat-icon>
                </button>
                <button mat-mini-fab
                        class="icon-button"
                        (click)="goToConsultantCvs(cv.userAccountId)"
                        matTooltip="{{'go_to_cv_list' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="format_list_bulleted" class="icon"></mat-icon>
                </button>
                <button mat-mini-fab
                        class="icon-button"
                        (click)="removeProfile(cv.userAccountId, cv['name'])"
                        matTooltip="{{'remove_profile' | translate}}"
                        matTooltipPosition="below"
                        matTooltipShowDelay="700">
                  <mat-icon svgIcon="delete" class="icon"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="not-found-text" colspan="4">{{ 'no_found' | translate }}</td>
          </tr>
        </table>
        <mat-paginator class="paginator-container" appPagination [pageSize]="30" [hidePageSize]='true' showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </app-card>
</div>

